module.exports = __webpack_public_path__ + "img/triangle-down.b01e3f01.svg";